import type { GroupAvatarFields, UserAvatarFields } from '@ms/yammer-graphql';

export const processUserAvatar: (value: UserAvatarFields) => {
  readonly avatarUrlTemplate: string | undefined;
} = (value) => ({
  avatarUrlTemplate: value.hasDefaultAvatar ? undefined : value.avatarUrlTemplate,
});

export const processGroupAvatar: (value: GroupAvatarFields) => {
  readonly avatarUrlTemplate: string | undefined;
} = (value) => ({
  avatarUrlTemplate: value.hasDefaultAvatar ? undefined : value.avatarUrlTemplate,
});
